import saddestSmiley from '../../img/smileys/saddest.svg';
import sadSmiley from '../../img/smileys/sad.svg';
import neutralSmiley from '../../img/smileys/neutral.svg';
import happySmiley from '../../img/smileys/happy.svg';
import happiestSmiley from '../../img/smileys/happiest.svg';

import star1 from '../../img/stars/1.png';
import star2 from '../../img/stars/2.png';
import star3 from '../../img/stars/3.png';
import star4 from '../../img/stars/4.png';
import star5 from '../../img/stars/5.png';

import number1 from '../../img/numbers/number-1-normal.svg';
import number2 from '../../img/numbers/number-2-normal.svg';
import number3 from '../../img/numbers/number-3-normal.svg';
import number4 from '../../img/numbers/number-4-normal.svg';
import number5 from '../../img/numbers/number-5-normal.svg';
import {

  QUESTION_TYPE_FIVESTARS,
  QUESTION_TYPE_SMILEYCOMMENT,
  QUESTION_TYPE_SMILEYQUARTET,
  QUESTION_TYPE_SMILEYQUINTET,
} from '../../constants';

export default {

  getLabels: (questionType, imageSize, useNumbersArg) => {

    const useNumbers = useNumbersArg || false;

    let images = {
      1: saddestSmiley,
      2: sadSmiley,
      3: happySmiley,
      4: happiestSmiley,
    };

    if (questionType === QUESTION_TYPE_FIVESTARS) {
      images = {
        1: star1,
        2: star2,
        3: star3,
        4: star4,
        5: star5,
      };
    }

    if (questionType === QUESTION_TYPE_SMILEYQUINTET) {
      if (!!useNumbers) {
        images = {
          1: number1,
          2: number2,
          3: number3,
          4: number4,
          5: number5,
        };
      } else {
        images = {
          1: saddestSmiley,
          2: sadSmiley,
          3: neutralSmiley,
          4: happySmiley,
          5: happiestSmiley,
        };
      }
    }

    switch (questionType) {
      case QUESTION_TYPE_FIVESTARS:
      case QUESTION_TYPE_SMILEYQUARTET:
      case QUESTION_TYPE_SMILEYQUINTET:
      case QUESTION_TYPE_SMILEYCOMMENT:
        return {
          useHTML: true,
          formatter: function () {
            return `<img 
              width="${imageSize}px"
              height="${imageSize}px"
              src="${images[this.value]}" />`;
          },
        };
      default:
        return {};
    }
  },

};



// WEBPACK FOOTER //
// ./src/services/chartHelper/chartHelper.js